import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=8cab3740&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"
import style0 from "./PatientForm.vue?vue&type=style&index=0&id=8cab3740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cab3740",
  null
  
)

export default component.exports